module.exports = __webpack_public_path__ + "img/fm.630c2d95.svg";